import { h, Host } from "@stencil/core";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
export class DateTime {
    constructor() {
        this.utc = "";
        this.format = "";
        this.formattedDateTime = "";
    }
    componentWillLoad() {
        const { utc, format } = this;
        if (utc === "" || format === "") {
            this.formattedDateTime = "";
            return;
        }
        const utcDate = dayjs.utc(utc);
        if (!utcDate.isValid()) {
            /* eslint-disable-next-line no-console */
            console.error(`ux-date-time received an invalid date. UTC: "${utc}"`);
            this.formattedDateTime = "";
            return;
        }
        this.formattedDateTime = utcDate.local().format(format);
    }
    render() {
        return h(Host, { key: 'eb2687b948023e9e0c9c40b244fe057d5265136d', class: "ux-date-time" }, this.formattedDateTime);
    }
    static get is() { return "ux-date-time"; }
    static get encapsulation() { return "shadow"; }
    static get properties() {
        return {
            "utc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "UTC time in a ISO_8601 Format https://en.wikipedia.org/wiki/ISO_8601 example: 2020-05-20 17:32:33"
                },
                "attribute": "utc",
                "reflect": true,
                "defaultValue": "\"\""
            },
            "format": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Format String according to https://day.js.org/docs/en/display/format example: \"DD.MM.YYYY HH:mm\".\nYou can escape characters by wrapping them in [].\nFor now this webcomponent displays localized parts in a date like \"Monday\" only in English"
                },
                "attribute": "format",
                "reflect": true,
                "defaultValue": "\"\""
            }
        };
    }
    static get states() {
        return {
            "formattedDateTime": {}
        };
    }
    static get watchers() {
        return [{
                "propName": "utc",
                "methodName": "componentWillLoad"
            }, {
                "propName": "format",
                "methodName": "componentWillLoad"
            }];
    }
}
//# sourceMappingURL=date-time.js.map
